// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/plesko4.png";
import thumb1 from "../assets/images/All-Products/plesko3.png";
import thumb2 from "../assets/images/All-Products/plesko4.png";
import thumb3 from "../assets/images/All-Products/plesko3.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("ingredients");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Pesklo </h2>
              <p className="sub-heading text-muted">Potent Effective Steroid for treatment of Moderate to Severe Plaque Psoriasis.</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>A potent and effective steroid used to treat a variety of skin conditions such as eczema, psoriasis, dermatitis, allergies, rash, and lichen planus.</li>
                  <li>Clobetasol reduces swelling, itching, and redness associated with these conditions.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Pesklo ?</span>
                </h3>
                <p>
                  Use Pesklo cream on the skin. Do not use it on the face, groin, or underarms unless directed to do so by your doctor.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["ingredients", "application"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "application"
                    ? "APPLICATION GUIDELINES"
                    : tab === "ingredients"
                      ? "INGREDIENTS"
                      : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">

              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Use Pesklo cream on the skin. Do not use it on the face, groin, or underarms unless directed to do so by your doctor.</li>
                      <li>Before cleaning and drying the affected area, wash and dry your hands properly. Apply a thin film of Pesklo cream to the affected area and gently rub in, usually 2 times daily or as directed by your doctor.</li>
                      <li>After applying Pesklo cream, wash your hands properly.</li>
                      <li>When applying near the eyes, avoid getting it in the eyes because this may worsen or cause glaucoma. Also avoid getting this in the nose; if you get the medication in these areas, rinse with plenty of water.</li>
                      <li>Use Pesklo cream only for the affected condition. Do not use it for longer than 2 weeks in a row or use more than 50 grams per week unless directed to do so by your doctor.</li>
                      <li>Inform your doctor if your condition persists or worsens after 2 weeks.</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    Clobetasol Propionate 0.05%: Clobetasol propionate has a strong immunosuppressive capacity which gives it anti-inflammatory, anti-pruritic & vasoconstrictive property along with strong immunosuppressive action. It makes intermittent treatment schedule feasible due to prolonged remission rate It also modulates immune response by controlling type 3 & 4 hypersensitivity reactions.
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
